import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { ROUTES } from '@constants/index'
import { getDefaultView } from '@utils/defaultView'
import { setLocalBasePath } from '@utils/navigationUtil'
import { setAppVisibleAllowed, setReadonlyMode } from '@redux/slices/workflowSlice'
import { useAppNavigate } from '@hooks/useAppNavigate'
import { OpenDrawerEventPayload } from '@typesApp/AppEvent'
import { usePathBuilder } from './usePathBuilder'

type UseOpenDrawerReturn = {
  openDrawer: (payload?: OpenDrawerEventPayload) => void
}

export const useOpenDrawer = (): UseOpenDrawerReturn => {
  const dispatch = useDispatch()
  const buildPath = usePathBuilder()
  const navigate = useAppNavigate()

  const openDrawer = useCallback(
    (payload?: OpenDrawerEventPayload) => {
      setLocalBasePath()

      dispatch(setAppVisibleAllowed())
      if (payload?.viewOnly) {
        dispatch(setReadonlyMode())
      }

      navigate(
        buildPath(payload?.target ?? getDefaultView(ROUTES.INSURANCE_MEMBER)),
        payload?.navigateState ? { state: payload?.navigateState } : undefined
      )

      if (typeof payload?.callback === 'function') {
        payload?.callback?.()
      }
    },
    [dispatch, buildPath, navigate]
  )

  return {
    openDrawer,
  }
}
